import { css } from '@emotion/react';
import { Theme } from '../config/theme';

export default (theme: Theme) => ({
  app: css`
    position: fixed;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100%;
    z-index: 300;
    display: flex;
    flex-direction: column;
    color: ${theme.color.secondary};
    font-family: ${theme.fontFamily.main};
    font-weight: ${theme.fontWeight.main};
    font-size: ${theme.fontSizes.base}
    line-height: ${theme.fontLineHeight.standard};
    p, span {
      font-size: ${theme.fontSizes.base};
    }
    h1 {
      font-size: ${theme.fontSizes.h1};
      font-weight: ${theme.fontWeight.header};
      margin-bottom: ${theme.spacing.extraLarge};
      margin-top: 0;
    }
    h2 {
      font-size: ${theme.fontSizes.h2};
      margin-top: 0;
    }
    h3 {
      font-size: ${theme.fontSizes.h3};
    }
    h4 {
      font-size: ${theme.fontSizes.h4};
    }
  `,
  blurOverlay: css`
    height: inherit;
    width: auto;
    background-color: ${theme.color.blurOverlay};
    -webkit-animation: 0.25s ease-in-out intentInFromTop;
    animation: 0.25s ease-in-out intentInFromTop;
  `,
});
